import React, { Component } from 'react';
import Slider from "react-slick";
import Modal from 'react-modal';

import slidedata from '../../../data/videocards';

function NextArrow(props) {
  const {  style, onClick } = props;
  return (
    <div
      className={ "fa fa-angle-right slick-arrow custom-slider-next"}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const {  style, onClick } = props;
  return (
    <div
      className={ "fa fa-angle-left slick-arrow custom-slider-prev"}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

class VideoSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slides: slidedata,
      isModelActive: false,
      videoUrl: "",
      autoPlay: false,
    };
  }
  componentWillMount() {
    Modal.setAppElement('body');
  }
  toggleVideoClick = (slide) => {
    this.setState({
      isModelActive: !this.state.isModelActive,
      videoUrl: slide.video,
      autoPlay: !this.state.autoPlay,
    });
  }
  render() {
    const that = this;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div>
        <Slider {...settings}>
          {this.state.slides.map(function (slide) {
            return (
              <div className="video-card" key={slide}>
                <div className="card-image" onClick={() => that.toggleVideoClick(slide)}>
                  <img src={slide.image} alt="tile" />
                  <div className="playButton">
                    <i className="fa fa-play"></i>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
        <Modal
          isOpen={this.state.isModelActive}
          onRequestClose={this.toggleVideoClick}
        >
          <video controls autoPlay={this.state.autoPlay}>
            <source src={this.state.videoUrl} type="video/mp4"/>
              Your browser does not support the video tag.
          </video>
          <button onClick={this.toggleVideoClick} className="modal-close-button"><i className="fa fa-times"></i></button>
        </Modal>
      </div>
    );
  }
}

export default VideoSlider;



// WEBPACK FOOTER //
// ./src/components/VideoSlideSection/VideoSlider/VideoSlider.js